import { addMonths, format, startOfMonth } from 'date-fns'

export const getDatePeriod = (date: Date) => {
	const firstDayCurrentMonth = startOfMonth(date)
	const firstDayNextMonth = startOfMonth(addMonths(date, 1))
	const formattedCurrent = format(firstDayCurrentMonth, 'yyyy-MM-dd')
	const formattedNext = format(firstDayNextMonth, 'yyyy-MM-dd')

	return { from: formattedCurrent, to: formattedNext }
}
